import React, { useState, useEffect } from 'react';
import { Alert, Button } from 'react-bootstrap';
import { createLogger } from '@graphistry/common/logger';
const logger = createLogger(__filename);

function ErrorFallback({error, resetErrorBoundary, children}) {
    const [show, setShow] = useState(true);

    useEffect(() => {
      if (show) {
        if (error.message === `Cannot read property 'offsetHeight' of null`) {
          logger.debug('Known exn, auto-retrying');
          setShow(() => false);
          setTimeout(resetErrorBoundary, 1);
        }
      }
    }, [show]);
  
    if (show) {
      return (
        <Alert variant="danger" onClose={() => setShow(false)} dismissible>
          <Alert.Heading>Uh oh - Unexpected error!</Alert.Heading>
          <p>
            You can close this error and try proceeding, or refresh the page.
            If possible, please reach out to your administrator or Graphistry with reproducible steps for triggering the error,
            and once we can duplicate it, we'll fix it for you.
          </p>
          <pre>{error.message}</pre>
          <Button onClick={() => setShow(false)}>dismiss</Button>
          <Button onClick={resetErrorBoundary}>retry action</Button>
        </Alert>
      );
    }
    return <Button variant="light" onClick={resetErrorBoundary}>retry action</Button>;
}

export { ErrorFallback };